<script lang="ts">
	import { page } from '$app/stores';
</script>

<svelte:head>
	{#if $page.data?.seo?.canonical}
		<link rel="canonical" href={$page.data.seo.canonical} />
		<meta property="og:url" content={$page.data.seo.canonical} />
	{/if}
	{#if $page.data?.seo?.title}
		<title>{$page.data.seo.title}</title>
		<meta property="og:title" content={$page.data?.seo?.ogTitle || $page.data.seo.title} />
	{/if}
	{#if $page.data?.seo?.description}
		<meta name="description" content={$page.data.seo.description} />
		<meta property="og:description" content={$page.data.seo.description} />
	{/if}
	{#if $page.data?.seo?.keywords}
		<meta name="keywords" content={$page.data.seo.keywords.join(', ')} />
	{/if}
</svelte:head>
